export default __webpack_public_path__ + "static/media/Amanita14.942322db.jpg";